import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { AiOutlineYoutube } from "react-icons/ai";

function Footer() {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <div>
      <section className="footer-main-sec home- padding-top  ms-auto w-100 float-left padding-bottom ">
        <div className="wrapper2">
          <div className="footer-inner-section d-flex justify-content-center text-center">
            <div className="footer-logo footer-box">
              <a href="/">
                <figure>
                  <img
                    src="../assets/images/logo/logo-light.svg"
                    width={120}
                    alt="logo"
                  />
                </figure>
              </a>
              <ul className="list-unstyled mb-0">
                <li className="d-inline-block ml-0 footer-icon">
                  <Link to="#">
                    <FaInstagram size={30} className="text-black " />
                  </Link>
                </li>
                <li className="d-inline-block ml-0 footer-icon">
                  <Link to="#">
                    <FaXTwitter size={30} className="text-black " />
                  </Link>
                </li>
                <li className="d-inline-block ml-0 footer-icon">
                  <Link to="#">
                    <FaFacebookF size={30} className="text-black " />
                  </Link>
                </li>

                <li className="d-inline-block ml-0 footer-icon">
                  <Link to="#">
                    <AiOutlineYoutube size={30} className="text-black " />
                  </Link>
                </li>
              </ul>
              <p className="mb-0">Copyright © {year} DNET.</p>
            </div>
            {/* <div className="footer-box">
              <h4>About</h4>
              <ul className="list-unstyled">
                <li>
                  <a href="about.html">About Company</a>
                </li>
                <li>
                  <a href="pricing.html">Our Solutions</a>
                </li>
                <li>
                  <a href="service.html">Our Best Services</a>
                </li>
                <li className="mb-0">
                  <a href="team.html">Professional Team</a>
                </li>
              </ul>
            </div>
            <div className="footer-box address-box">
              <h4>Address</h4>
              <ul className="list-unstyled">
                <li className="position-relative">
                  <i className="fas fa-map-marker-alt" /> 551 Swanston Street,
                  Melbourne <br /> Victoria 3053 Australia
                </li>
                <li className="position-relative">
                  <i className="fas fa-phone-volume" />{" "}
                  <a href="tel:+61383766284">+61 3 8376 6284</a>
                </li>
                <li className="mb-0 position-relative">
                  <i className="fas fa-envelope" />{" "}
                  <a href="mailto:info@designingmedia.com">
                    info@designingmedia.com
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-box footer-form-box">
              <h4>Newsletter Signup</h4>
              <ul className="list-unstyled">
                <li className="position-relative mb-0">
                  <input type="text" placeholder="Enter Your Email Address" />{" "}
                  <button>Send</button>
                </li>
              </ul>
              <form action="https://html.designingmedia.com/action_page.php">
                <input
                  type="checkbox"
                  id="policy"
                  name="policy"
                  defaultValue="Bike"
                />
                <label htmlFor="policy" className="check-box" />
                <label htmlFor="policy">
                  {" "}
                  I agree to the <a href="#">Privacy Policy</a>.
                </label>
                <br />
              </form>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
